(function ($) {
    $(document).foundation();

    /**
     * Initialize ScrollTrigger for scroll animations.
     */
    document.addEventListener('DOMContentLoaded', function () {
        var trigger = new ScrollTrigger({
            toggle: {
                visible: 'fromTopIn',
                hidden: 'fromTopOut'
            },
            offset: {
                x: 0,
                y: 20
            },
            // addHeight: true,
            // addWidth: true,
            // centerVertical: true,
            once: true
        }, document.body, window);
    });

    /**
     * Capabilities Hover
     *
     * Switch background image when the links are hovered.
     *
     * @type {*|HTMLElement}
     */
    const imgContainer = $('.home-capabilities-images');
    const originalBackground = imgContainer.css('background-image');

    $('.home-capabilities-nav')
        .on('mouseleave', 'a', function () {
            imgContainer.css('background-image', originalBackground);
        })
        .on('mouseenter', 'a', function () {
            imgContainer.css('background-image', `url(${this.dataset.hover})`);
        });

})(jQuery);
